/**
 * These are routes defined for the application in the form given to the react router.
 * Importantly these can include parameters, e.g. /quiz/:quizId
 */
export enum AppRoutes {
  LANDING_PAGE = '/',
  INTRO_PAGE = '/intro',
  LOGIN = '/login',
  LOGOUT = '/logout',
  AUTH_CALLBACK = '/auth-callback',
  QUIZ_PROFILE_SELECTION = '/quiz/profile-selection',
  QUIZ_QUESTION = '/quiz/question',
  BOOKMARKS = 'bookmarks',
  PROGRESS = 'in-progress',
  LIBRARY = '/library',
  YOUR_LEARNING = '/your-learning',
  RESOURCE_MANAGER = '/resource-manager',
  RECOMMENDATIONS = 'recommendations',
  RECOMMENDATIONSV2 = 'recommendations-v2',
  TOPIC_MANAGER = '/topic-manager',
  STATS = 'stats',
  SANDBOX = '/sandbox',
  ERROR_404 = '/404',
  ERROR_403 = '/403',
  ERROR_500 = '/500',
}

export const getRecommendationsPath = () => `${AppRoutes.YOUR_LEARNING}/${AppRoutes.RECOMMENDATIONS}`;
export const getStatsPath = () => `${AppRoutes.YOUR_LEARNING}/${AppRoutes.STATS}`;
export const getBookmarksPath = () => `${AppRoutes.YOUR_LEARNING}/${AppRoutes.BOOKMARKS}`;
export const getProgressPath = () => `${AppRoutes.YOUR_LEARNING}/${AppRoutes.PROGRESS}`;




export enum AppExternalRoutes {
  MANAGERS_DASHBOARD = 'https://universityofexeteruk.sharepoint.com/sites/DataHub/SitePages/Digital-Skills.aspx?ga=1',
}

/**
 * These are the URLs that are used in the application. They are derived from the routes above,
 * for each route there is one function that allows any parameters to be set in a typesafe way
 */
export const APP_URLS = {
  landingPage: () => AppRoutes.LANDING_PAGE,
  introPage: () => AppRoutes.INTRO_PAGE,
  login: (redirect?: string) => AppRoutes.LOGIN + (redirect ? `?redirect=${redirect}` : ''),
  quizProfileSelection: () => AppRoutes.QUIZ_PROFILE_SELECTION,
  quizQuestion: () => AppRoutes.QUIZ_QUESTION,
  bookmarks: () => AppRoutes.BOOKMARKS,
  library: () => AppRoutes.LIBRARY,
  yourLearning: () => AppRoutes.YOUR_LEARNING,
  stats: () => AppRoutes.STATS,
  learningProgress: () => AppRoutes.PROGRESS,
  recommendations: () => AppRoutes.RECOMMENDATIONS,
  resourceManager: () => AppRoutes.RESOURCE_MANAGER,
  topicManager: () => AppRoutes.TOPIC_MANAGER,
  error403: AppRoutes.ERROR_403,
  error404: AppRoutes.ERROR_404,
  error500: AppRoutes.ERROR_500,
  managersDashboard: () => AppExternalRoutes.MANAGERS_DASHBOARD,
} as const;
